import template from './invoice-details.html';
import controller from './invoice-details.controller';

let invoiceDetailsComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default invoiceDetailsComponent;



// WEBPACK FOOTER //
// ./client/pages/admin/invoice-details/invoice-details.component.js